import { FC } from 'react';
import { AvailableBonusesTransactionsStatuses, GameData } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useGameHandleClick } from 'src/components/GameCard/utils/useGameHandleClick';
import { GameImage } from 'src/components/GameImage';
import { Skeletons } from 'src/components/Skeletons';

interface GameBlockProps {
  isShowButtons: boolean;
  updateBonus: (status: AvailableBonusesTransactionsStatuses) => Promise<void>;
  game: GameData;
  isLoadingGame: boolean;
}

export const GameBlock: FC<GameBlockProps> = ({
  isShowButtons,
  updateBonus,
  game,
  isLoadingGame
}) => {
  const { t } = useTranslation();
  const { handlePlayGameClick } = useGameHandleClick({
    game,
    onClick: () => updateBonus('Activated')
  });

  if (!game) return;

  if (isLoadingGame) {
    return <Skeletons className="w-[307px] h-[70px] mb-5" />;
  }

  return (
    <div className="flex flex-row w-[308px] p-2 gap-3 bg-jm_block_game_bg mb-5 items-center rounded-[8px]">
      <GameImage game={game} className="w-[80px] h-[80px] object-fill rounded-[6px]" />
      <div className="flex flex-col max-w-[150px] gap-1 text-start">
        <p className="text-jm_block_game_name font-bold text-sm">{game?.name}</p>
        <p className="font-normal text-xs text-jm_block_game_text">{game?.providerName}</p>
      </div>
      {isShowButtons && (
        <Button onClick={handlePlayGameClick} className="w-fit min-w-20">
          {t('shop.secondCardButtonText')}
        </Button>
      )}
    </div>
  );
};
